import { Button, Field, Input } from '@cloudflare/kumo';
import { useState } from 'react';
import { ICONS } from '../ui/icons';

/**
 * Edição na própria linha: o lápis aparece ao passar o mouse; Enter salva,
 * Esc cancela. Erro do servidor fica no campo, sem perder o que foi digitado.
 */
export function InlineEdit({ value, label, placeholder, type = 'text', disabled, onSave, render }: {
  value: string;
  label: string;
  placeholder?: string;
  type?: 'text' | 'email';
  disabled?: boolean;
  onSave: (value: string) => Promise<void>;
  render?: (value: string) => React.ReactNode;
}) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const start = () => { setDraft(value); setError(null); setEditing(true); };
  const save = async () => {
    if (draft.trim() === value.trim()) { setEditing(false); return; }
    setSaving(true); setError(null);
    try { await onSave(draft.trim()); setEditing(false); } catch (err) { setError(err instanceof Error ? err.message : 'Não foi possível salvar'); } finally { setSaving(false); }
  };
  const onKey = (e: { key: string; preventDefault: () => void }) => {
    if (e.key === 'Enter') { e.preventDefault(); save(); }
    if (e.key === 'Escape') { e.preventDefault(); setEditing(false); }
  };

  if (editing) {
    return (
      <div className="atlas-inline-edit">
        {/* O rótulo fica só para leitores de tela (o layout é compacto); o erro
            do servidor é exibido pelo próprio FormField. */}
        <Field label={<span className="sr-only">{label}</span>} error={error ?? undefined ? { message: error ?? undefined, match: true } : undefined}>
          <Input onChange={(e) => setDraft(e.target.value)} onKeyDown={onKey} type={type} value={draft} placeholder={placeholder} autoFocus disabled={saving} />
        </Field>
        <Button variant="ghost" shape="square" icon={ICONS.Checkmark} aria-label="Salvar" onClick={save} disabled={saving} />
        <Button variant="ghost" shape="square" icon={ICONS.X} aria-label="Cancelar" onClick={() => setEditing(false)} disabled={saving} />
      </div>
    );
  }
  return (
    <div className="atlas-inline-view">
      {render ? render(value) : <span>{value || '—'}</span>}
      {!disabled && (
        <Button variant="ghost" shape="square" icon={ICONS.Edit} aria-label={`Editar ${label.toLowerCase()}`} className="atlas-inline-pencil" onClick={start} />
      )}
    </div>
  );
}
